import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { WindowComponent } from 'movisat-common-gui';
import { AppComponent } from 'src/app/app.component';
import { CuadriculaFormModel } from 'src/app/services/cuadricula/models/cuadricula.model';
import { debounce } from 'lodash';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { ZonaModel } from 'src/app/services/zones/models/zona.model';
import { MapBounds, MapLatLng } from 'movisat-maps';

@Component({
  selector: 'app-editar-cuadricula',
  templateUrl: './editar-cuadricula.component.html',
  styleUrl: './editar-cuadricula.component.css'
})
export class EditarCuadriculaComponent implements AfterViewInit {
  @ViewChild('formCuadricula') public formCuadricula: WindowComponent;
  @ViewChild('ddZonas') public ddZonas: jqxDropDownListComponent;

  @Output() protected closeForm = new EventEmitter;
  @Output() protected createMarco = new EventEmitter;
  @Output() protected cuadriculaOutput = new EventEmitter<CuadriculaFormModel>;

  @Input() protected zonas: ZonaModel[];
  @Input() protected lado_minimo_cuadricula: number;
  @Input() protected cuadricula: CuadriculaFormModel;

  public ngAfterViewInit(): void {
    this.cargarZonasOnDropDown();

    if(this.cuadricula.id === 0) {
      this.ddZonas.selectIndex(0);
    } else {
      const ddZonasItems = this.ddZonas.getItems();
      const index = ddZonasItems.findIndex(i => i.value?.Id === this.cuadricula.idZona);
      this.ddZonas.selectIndex(index);
    }
  }

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  protected actions = [
    {type: "button", action:"save", value: "", label: this.translate('Guardar')},
    {type: "button", action:"cancel", value: "", label: this.translate('CANCELAR')}
  ];

  public actionButtonClicked(event): void {
    if(event.action === 'save') {
      this.cuadriculaOutput.emit(this.cuadricula)
      return;
    }

    if(event.action === 'cancel') {
      this.onCancelBtn();
      return;
    }
  }

  private onCancelBtn(): void {
    this.formCuadricula.closeWindow();
  }

  protected changeLado = debounce(() => {
    this.createMarco.emit();
  }, 800);

  public onChangeZona(zona: ZonaModel, label: string): void {
    if(!zona) {
      return;
    }

    this.cuadricula.idZona = zona.Id;
    this.cuadricula.zona = label;

    this.cuadricula.marco = this.calcMarco(zona.Geometria.geometry.coordinates);
    this.createMarco.emit()
  }

  public cargarZonasOnDropDown(): void {
    this.ddZonas.addItem({ label: 'Seleccione una zona', value: null });
    this.ddZonas.selectedIndex(0);

    // Recorrer y añadir las zonas disponibles
    this.zonas.forEach((zona, index) => {
      // Carga el listado las zonas que no sean circulos
      if(zona.TipoGeo !== 0) {
        this.ddZonas.addItem({ label: zona.Nombre, value: zona });

        // Comprobar si la zona de alarmaEdit coincide con alguna y seleccionarla
        if (this.cuadricula.idZona && this.cuadricula.idZona === zona.Id) {
          this.ddZonas.selectedIndex(index + 1); // Se suma 1 por la opción vacía
        }
      }
    });
  }

  private calcMarco(coordenadas: [[[]]]): MapBounds {
    const swCorner = new MapLatLng(90, 180);
    const neCorner = new MapLatLng(-90, -180);

    coordenadas[0][0].forEach(c => {
      if (c[0] > neCorner.lng) {
        neCorner.lng = c[0];
      }
      if (c[1] > neCorner.lat) {
        neCorner.lat = c[1];
      }

      if (c[0] < swCorner.lng) {
        swCorner.lng = c[0];
      }
      if (c[1] < swCorner.lat) {
        swCorner.lat = c[1];
      }
    });

    return new MapBounds(swCorner, neCorner);
  }

  protected onCloseForm(): void {
    this.closeForm.emit();
  }
}

